<div id="contact-us" class="right-navigation showModal">

    <div class="component">

        <div class="header border-bottom">
            <div class="font-primary-subtitle bold contact-us-header">
                {{'consultation_selection' | translate}}
            </div>

            <div (click)="closeModal('CLOSE')" class="float-right closeicon pointer">
                <img src="./assets/icons/close_grey.svg">
            </div>
        </div>

        <div class="content">

            <div class="section">
                <label class="section-label">
                    {{ 'consult_type' | translate }}
                </label>

                <div class="radio-group">
                    <label class="radio-option" *ngFor="let option of consultationOptions"
                        [class.active]="selectedConsultationType === option.value">
                        <input type="radio" name="consultType" [value]="option.value"
                            [(ngModel)]="selectedConsultationType" (change)="onRadioChange(option)" />

                        <img [src]="option.icon" />

                        <span>{{ option.label | translate }}</span>
                    </label>
                </div>
            </div>

        </div>

        <div class="footer">
            <button class="btn btn-primary" [disabled]="!selectedConsultationType" (click)="onConfirm()">
                {{ 'continue_btn' | translate }}
            </button>
        </div>

    </div>
</div>